import {
  LIST_ITEM_CLASSIFICATION_REQUEST,
  LIST_ITEM_CLASSIFICATION_SUCCESS,
  LIST_ITEM_CLASSIFICATION_FAIL,
  LIST_ITEM_CLASSIFICATION_SUMMARY_REQUEST,
  LIST_ITEM_CLASSIFICATION_SUMMARY_SUCCESS,
  LIST_ITEM_CLASSIFICATION_SUMMARY_FAIL,
  CREATE_ITEM_CLASSIFICATION_REQUEST,
  CREATE_ITEM_CLASSIFICATION_SUCCESS,
  CREATE_ITEM_CLASSIFICATION_FAIL,
  UPDATE_ITEM_CLASSIFICATION_REQUEST,
  UPDATE_ITEM_CLASSIFICATION_SUCCESS,
  UPDATE_ITEM_CLASSIFICATION_FAIL,
  DELETE_ITEM_CLASSIFICATION_REQUEST,
  DELETE_ITEM_CLASSIFICATION_SUCCESS,
  DELETE_ITEM_CLASSIFICATION_FAIL,
  DETAIL_ITEM_CLASSIFICATION_REQUEST,
  DETAIL_ITEM_CLASSIFICATION_SUCCESS,
  DETAIL_ITEM_CLASSIFICATION_FAIL
} from '../../constants/item-classifications'

const initialState = {
  loading: false,
  itemClassifications: [],
  itemClassificationsSummary: [],
  itemClassification: {},
  pageable: {
    page: 1,
    size: 10
  },
  loadingCreate: false,
  loadingDetail: false,
  loadingUpdate: false,
  error: null
}

const itemClassificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_ITEM_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ITEM_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        itemClassifications: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_ITEM_CLASSIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        itemClassifications: action?.dummy
      }
    case LIST_ITEM_CLASSIFICATION_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_ITEM_CLASSIFICATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        itemClassificationsSummary: action.payload
      }
    case LIST_ITEM_CLASSIFICATION_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_ITEM_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_ITEM_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        itemClassifications: [...state.itemClassifications, action.payload]
      }
    case CREATE_ITEM_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_ITEM_CLASSIFICATION_REQUEST:
      return { ...state, loadingDetail: true, itemClassification: {} }
    case DETAIL_ITEM_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        itemClassification: action.payload
      }
    case DETAIL_ITEM_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        itemClassification: {}
      }
    case UPDATE_ITEM_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_ITEM_CLASSIFICATION_SUCCESS:
      const updatedServiceClassification = action.payload
      const updateFindIndexServiceClassification =
        state.itemClassifications.findIndex(
          (title) => title.id === updatedServiceClassification.id
        )
      const updatedServiceClassifications = [...state.itemClassifications]
      updatedServiceClassifications[updateFindIndexServiceClassification] =
        updatedServiceClassification

      return {
        ...state,
        loadingUpdate: false,
        itemClassifications: updatedServiceClassifications
      }
    case UPDATE_ITEM_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_ITEM_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_ITEM_CLASSIFICATION_SUCCESS:
      const deletedServiceClassificationId = action.payload
      const deletedFindIndexServiceClassification =
        state.itemClassifications.findIndex(
          (title) => title.id === deletedServiceClassificationId
        )
      const deletedServiceClassifications = [...state.itemClassifications]
      deletedServiceClassifications.splice(
        deletedFindIndexServiceClassification,
        1
      )

      return {
        ...state,
        loadingDelete: false,
        itemClassifications: deletedServiceClassifications
      }
    case DELETE_ITEM_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default itemClassificationReducer
